import React from 'react';
import "../../styles/support/feedback_thanks.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import doneImage from "../../images/support/done_image.png";

const FeedbackThanks = ({getShow, setShow}) => {
    const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => {
            setShow(false);
            navigate("/main_back/support");
        }, 1500);
    }, [setShow, navigate])

    return(
        <div className={`feedback_thanks_dialog ${getShow ? "show" : ""}`}>
            <div className="feedback_thanks_overlay"></div>
            <div className="feedback_thanks_content">
                <p className="feedback_thanks_dialog_header">Feedback Received</p>
                <img className="feedback_thanks_dialog_image" src={doneImage} alt="We have received your feedback." />
            </div>
        </div>
    );
};

export default FeedbackThanks;